import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { SalesOrderHeader, SalesOrderHeaderNarrative } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderNarrativeService extends TmsWebBaseEditService<SalesOrderHeader, SalesOrderHeaderNarrative> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesOrderNarrative', $localize`Sales Order Header Narrative`);
  }
}
